module.exports = ".share {\n  font-family: OpenSans;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #404040;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/badges/badges.component.css
// module id = ./src/app/myprofile/badges/badges.component.css
// module chunks = main